module.exports = __webpack_public_path__ + "static/media/back-sketch.a06cdb43.svg";